module.exports = __webpack_public_path__ + "static/media/mao.f29ccd01.svg";